import React from 'react';
import { TableCell } from 'carbon-components-react';
import { NoImage24 } from '@carbon/icons-react';

import { isObject } from 'lodash';

const RowItem = (props: any) => {
  const cell = props.cell;
  const title = cell.info.header;

  return title === 'icon' ? (
    <TableCell className="icon-cell">
      {cell.value !== undefined ? (
        <img src={cell.value} width="24" height="24" alt="" />
      ) : (
        <NoImage24 />
      )}
    </TableCell>
  ) : (
    <TableCell>
      {isObject(cell.value) // This object type cell should have {key1: value1, key2: value2...}, use { key1: { noPara: true, value: value1 }} to opt of not using paragraph
        ? Object.values(cell.value).map((item: any, i: any): any => {
            return item.noPara ? (
              <div key={i}>{item.value}</div>
            ) : (
              <p key={i}>{item}</p>
            );
          })
        : cell.value}
    </TableCell>
  );
};

export default React.memo(RowItem);
